import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const ADMIN_GENERAL_SETTINGS_NOTIFICATIONS_ROUTE_NAME = Symbol('admin.settings.notifications');
export const TRANSLATION_GROUP_GENERAL_SETTINGS_NOTIFICATIONS = Symbol('general-settings.notifications');

export const SETTINGS_NOTIFICATIONS_LIST_URL = 'admin/notifications';
export const SETTINGS_NOTIFICATIONS_SAVE_URL = 'admin/notifications/:id';

export const SETTINGS_NOTIFICATIONS_LIST_QUERY_KEY = 'general-settings.notifications.list';
export const SETTINGS_NOTIFICATIONS_SAVE_QUERY_KEY = 'general-settings.notifications.save';

export const ADMIN_GENERAL_SETTINGS_NOTIFICATIONS_PERMISSIONS = {
  NOTIFICATIONS_SHOW: new Permission(PermissionsList.admin.NOTIFICATIONS_SHOW),
};
